import React, { useLayoutEffect } from 'react';
import { xs_isMobile } from '../..';
import { getLabel } from '../../data/labels';
import { BetslipContext } from '../betslip/BetslipConf';
import { classIf, getConfiguration, getCurrencyValue } from '../utils';
import { startCartPositioning } from './cartPositioning';
import Coupon from './Coupon';
import ReservationBox from './ReservationBox';
import Settings from './Settings';
import LiveScoresProvider from './LiveScoresProvider';
import BetslipLoader from './BetslipLoader';
import ReservationDetail from '../betslip/reservation-detail/ReservationDetail';

import '../../common/betslip-alt.css';

export function pinCart() {
    const sidebarDx = document.querySelector("#sidebar-dx");
    sidebarDx.classList.add("h-auto");

    const cart = document.querySelector(".--js-target-for-cartPin");
    cart.classList.add("cart--pinned");

    const cartMaxHeightCSSVariable = "--js-pinned-cart-maxHeight";
    const cartTop = cart.getBoundingClientRect().top;
    const viewportHeight = document.documentElement.offsetHeight;
    const tolerance = 10; // Tolleranza di 10 px tra il fondo del carrello e il fondo della pagina
    const cartMaxHeight = viewportHeight - cartTop - tolerance + "px";
    document.querySelector(":root").style.setProperty(cartMaxHeightCSSVariable, cartMaxHeight);
}

export function unpinCart() {
    const sidebarDx = document.querySelector("#sidebar-dx");
    sidebarDx.classList.remove("h-auto");

    const cart = document.querySelector(".--js-target-for-cartPin");
    cart.classList.remove("cart--pinned");
}

export default function BetslipAlt(props) {
    const conf = getConfiguration();
    const betslipContext = React.useContext(BetslipContext);

    let betslipData = betslipContext.getBetslipData();
    const couponKey = betslipData.selectedCoupon;
    const coupon = betslipData.coupons[couponKey];
    const tabAttivo = coupon.selectedContainer;
    const containerOrder = conf.bco;
    const fastBetEnabled = betslipContext.isAddAndBetEnabled();
    const fastbetAmount = getCurrencyValue(betslipContext.addAndBetAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
    const showSettings = betslipContext.isBetslipSettingsVisible();
    
    let reservations = betslipContext.getReservations();
    reservations = reservations == null? [] : reservations;
    const showReservationsBox = betslipContext.showedReservationBox && !betslipContext.betBuilderMatch;
    

    function toggleReservationBox() {
        betslipContext.toggleReservationBox();
    }

    function showBetslipCoupon(keyCoupon) {
    	betslipData.selectedCoupon = keyCoupon + "";
    	betslipContext.setBetslipData(betslipData, true);
    	betslipContext.restoreReservationBoxStatus();
    }

    function toggleFastbet() {
        if (betslipContext.isAddAndBetEnabled()) {
            betslipContext.disableAddAndBet();
        } else {
            props.toggleFastbetPopup();
        }
    }

    function toggleSettingsDropdown(e) {
        betslipContext.toggleBetslipSettings();
    }
    
    function showContainer(container) {
    	betslipContext.changeContainer(container);
    }

    useLayoutEffect(() => {
        if (xs_isMobile) {
            startCartPositioning.init(
                ".cart__header",
                ".cart__body",
                ".cart__footer",
                ".xs_bottomNavbar"
            );
        }
    }, []);

    const isPinned = betslipContext.isScrollable();
    useLayoutEffect(() => {
        if (!xs_isMobile) {
            if (isPinned) {
                pinCart();
            } else {
                unpinCart();
            }
        }
    }, [isPinned]);
    
    return (
        <LiveScoresProvider>
            <div className="cart --js-target-for-cartPin">
                <div className="cart__header">
                    <div className="cart__controlsRow">
                        <div className="cart__title">{betslipContext.betBuilderMatch? (getLabel('betbuilder.match_header') + ' ' + betslipContext.betBuilderMatch.desc) : (getLabel('betslip.header.ticket', 'Ticket ') + betslipData.selectedCoupon)}</div>
                        <div className="cart__controls">
                            {!betslipContext.betBuilderMatch && <>
	                            <div className="cart__control" onClick={toggleReservationBox}>
	                                <div className={"cart__control__img cart__control__img--ticket" + classIf(showReservationsBox, 'cart__control--active')}></div>
	                                <div className="cart__badge">{reservations.length}</div>
	                            </div>
	                            <div className={"cart__control" + classIf(showSettings, 'cart__control--active')} onClick={toggleSettingsDropdown}>
	                                <div className="cart__control__img cart__control__img--settings"></div>
	                            </div>
                            </>
                            }

                            {!xs_isMobile &&
                                <div className={"cart__control cart__control--pin" + classIf(betslipContext.isScrollable(), 'cart__control--active')} onClick={() => betslipContext.toggleScrollable()}>
                                    <div className="cart__control__img cart__control__img--pin"></div>
                                </div>
                            }
                            <div className="cart__control" onClick={() => props.toggleBetslip()}>
                                <div className="cart__control__img cart__control__img--close"></div>
                            </div>
                        </div>
                    </div>
                    {showSettings &&
                        <div className="cart__settingsRow">
                            <Settings />
                        </div>
                    }
                    {!betslipContext.betBuilderMatch &&
	                    <div className="cart__quickBetRow">
	                        <div className="customInput customInput--toggle">
	                            <label>
	                                <input type="checkbox" checked={fastBetEnabled} onChange={toggleFastbet} />
	                                <span></span>
	                                <div className="customInput__description">{getLabel('general.fastbet')}</div>
	                            </label>
	                        </div>
	                        {fastBetEnabled &&
	                            <div className="cart__quickBetRow__calculatorInput calculatorInput" onClick={() => props.toggleFastbetPopup()}>{fastbetAmount}</div>
	                        }
	                        <div className="cart__quickBetRow__myBetsButton myBetsButton" onClick={() => props.toggleMyBets()}>
	                            {xs_isMobile &&
	                                <span className="myBetsButton__text">{getLabel('general.mybets')}</span>
	                            }
	                            <span className="myBetsButton__img"></span>
	                        </div>
	                    </div>
                    }
                    {!betslipContext.betBuilderMatch &&
	                    <div className="cart__navRow">
	                        {Object.keys(betslipData.coupons).map(key => {
	                            let classes = '';
	                            if (key === betslipData.selectedCoupon) {
	                                classes += ' cart__navTab--active'
	                            }
	                            if (betslipData.coupons[key].selections.length > 0) {
	                                classes += ' cart__navTab--dotted';
	                            }
	                            function handleClick(e) {
	                                e.stopPropagation();
	                                showBetslipCoupon(key);
	                            }
	                            return (
	                                <div key={key} className={"cart__navTab" + classes} onClick={handleClick}>
	                                    {key}
	                                </div>
	                            );
	                        })}
	                    </div>
                    }
                    <div className="cart__betTypeRow">
                       	{!betslipContext.betBuilderMatch &&
	                        <div className="cart__betTypeButtons">
	                            {Object.keys(containerOrder).map(key => {
	                                    const tabValue = containerOrder[key];
	                                    let label = null;
	                                    if (tabValue === 'singlebets') {
	                                        label = getLabel('betslip_alt.single_bets');
	                                    } else if (tabValue === 'multibets') {
	                                        label = getLabel('betslip_alt.multiple_bets');
	                                    } else {
	                                        label = getLabel('betslip_alt.system_bets');
	                                    }
	                                    return (
	                                        <div key={`container-${tabValue}-coupon-${couponKey}`}
	                                                className={"cart__betType" + classIf(tabAttivo === tabValue, 'cart__betType--active')} 
	                                                onClick={() => {showContainer(tabValue)}}>
	                                            {label}
	                                        </div>
	                                    );
	                                })
	                            }
	                        </div>
                        }
                        <div className="emptySlipButton" onClick={() => betslipContext.clearBetslip()}>
                            <div className="emptySlipButton__text">{coupon.selections.length}</div>
                            <div className="emptySlipButton__img"></div>
                        </div>
                    </div>
                </div>
                <div className="cart__overflowContainer">
                    {function() {
                        if (showReservationsBox) {
                            return <ReservationBox couponKey={couponKey} />;
                        } else {
                            return (
                                <Coupon couponKey={couponKey} />
                            );
                        }
                    }()}
                </div>
                <BetslipLoader />
                {betslipContext.showReservationDetail &&
                    <div className="cart_overlayWrapper">
                        <ReservationDetail />
                    </div>
                }
            </div>
        </LiveScoresProvider>
    );
}
